'use client';

import { useContext, useEffect } from 'react';
import { AuthContext } from 'src/context/auth-context/auth-context';
import { identifyFullStoryUser } from 'src/lib/fullstory';

const FullStoryUserIdentifier = () => {
	const [userDetails] = useContext(AuthContext);

	useEffect(() => {
		if (!userDetails?.property_manager_id) return;

		const displayName = [userDetails.first_name, userDetails.last_name]
			.filter(Boolean)
			.join(' ')
			.trim();

		identifyFullStoryUser(
			String(userDetails.property_manager_id),
			displayName,
			userDetails.email,
		);
	}, [userDetails]);

	return null;
};

export default FullStoryUserIdentifier;
